module.exports = "/_next/static/images/ru_3-f40e958f2a6597e225c219a233b3ff0c.jpg";